import Swiper, {Navigation, Pagination} from "swiper";

Swiper.use([Navigation, Pagination])
export function initMainVideoSlider(){

    let swiper = new Swiper('#main_video_slider', {
        speed: 900,
        preloadImages: false,
        spaceBetween: 32,
        allowTouchMove: true,
        slidesPerView: 'auto',
        pagination:{
            el: '.main-video-slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.main-video-swiper-next',
            prevEl: '.main-video-swiper-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 32,
            }
        }
    });
}